<template>
  <div>
    <v-row dense cols="12">
      <v-col cols="4" class="mt-2">Current sales amount</v-col>
      <v-col cols="2" class="mt-1 pr-3">
        <input_amount label="" prefix="€" :amount="wizardData.sales_old" field="sales_old" @updateData="updateData"/>
      </v-col>
      <v-col cols="3" span="3" class="mt-2 text-center">new amount</v-col>
      <v-col cols="2" class="mt-1 pr-3">
        <input_amount label="" prefix="€" :amount="wizardData.sales_new" field="sales_new" @updateData="updateData"/>
      </v-col>
    </v-row>
    <v-row dense cols="12">
      <v-checkbox
              dense
              v-model="wizardData.useAllExactFromAmountWildcard"
              label="Use from amount 0 as a wildcard for all 'from amounts'"
              color="warning"
              v-on:change="updateData"
              hide-details
            ></v-checkbox>           
    </v-row>  
  </div>
</template>

<script>

  import input_amount from '@/components/huis/hspt/ui/input_amount.vue';

  export default {
    props: {
      wizardData: Object
    },
    components: {
      input_amount, 
    },
    methods:{
      updateData(data){
        this.$emit('updateData', data);
      },
      updateUseWildCard(data){
        this.updateData({"field": "useAllExactFromAmountWildcard", "value": data});
      },            
    },    
  }
</script>

<style scoped>

</style>